/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CodeStub } from './CodeStub'

/**
 * List of care team members assigned for the healthcare element.
 */
export class CareTeamMember {
  constructor(json: JSON | any) {
    Object.assign(this as CareTeamMember, json)
  }

  id?: string
  careTeamMemberType?: CareTeamMember.CareTeamMemberTypeEnum
  healthcarePartyId?: string
  quality?: CodeStub
  /**
   * The base64 encoded data of this object, formatted as JSON and encrypted in AES using the random master key from encryptionKeys.
   */
  encryptedSelf?: string
}
export namespace CareTeamMember {
  export type CareTeamMemberTypeEnum = 'physician' | 'specialist' | 'other'
  export const CareTeamMemberTypeEnum = {
    Physician: 'physician' as CareTeamMemberTypeEnum,
    Specialist: 'specialist' as CareTeamMemberTypeEnum,
    Other: 'other' as CareTeamMemberTypeEnum,
  }
}
